import React from "react";
import ConnectionList from "./components/ConnectionList";
import ConnectionSuccessModal from "./components/ConnectionSuccessModal";
import CreateConnectionForm from "./components/CreateConnectionForm";
import DeleteConnectionModal from "./components/DeleteConnectionModal";
import QRCodeScanner from "./components/QRCodeScanner";
import { useWhatsappConnectionsScreen } from "./hooks/useWhatsappConnectionsScreen";

interface WhatsappConnectionsProps {
  searchTerm?: string;
  onSearchChange?: (v: string) => void;
  onAddConnectionRef?: (fn: () => void) => void;
}

const WhatsappConnections: React.FC<WhatsappConnectionsProps> = ({
  searchTerm: externalSearch,
  onSearchChange,
  onAddConnectionRef,
}) => {
  const {
    step,
    setStep,
    isLoading,
    qrCode,
    error,
    startConnection,
    cancelConnection,
    resetFlow,
    connections,
    isLoadingConnections,
    handleDeleteClick,
    handleDeleteConfirm,
    handleDisconnect,
    handleReconnect,
    deleteState,
    closeDelete,
    showSuccessModal,
    closeSuccessModal,
  } = useWhatsappConnectionsScreen(onAddConnectionRef);

  return (
    <div className="w-full">
      {step === "list" && (
        <ConnectionList
          connections={connections}
          isLoading={isLoadingConnections}
          onAddConnection={() => setStep("create")}
          onDeleteConnection={handleDeleteClick}
          onDisconnect={handleDisconnect}
          onReconnect={handleReconnect}
          searchTerm={externalSearch}
          onSearchChange={onSearchChange}
        />
      )}

      {step === "create" && (
        <CreateConnectionForm
          onBack={resetFlow}
          onSubmit={startConnection}
          isLoading={isLoading}
          error={error}
        />
      )}

      {step === "qrcode" && (
        <QRCodeScanner
          qrCode={qrCode || ""}
          onCancel={() => {
            cancelConnection();
            setStep("list");
          }}
          onRefresh={async () => {
            // Nada — o polling já está buscando
          }}
          isLoading={!qrCode}
        />
      )}

      <DeleteConnectionModal
        isOpen={deleteState.isOpen}
        connectionName={deleteState.connectionName}
        onConfirm={handleDeleteConfirm}
        onCancel={closeDelete}
      />

      <ConnectionSuccessModal
        isOpen={showSuccessModal}
        onClose={closeSuccessModal}
        autoRedirectMs={5000}
      />
    </div>
  );
};

export default WhatsappConnections;
